<template>
    <v-card class="mt-2" v-if="hasRooms">
        <v-toolbar>
            <v-toolbar-title
                :class="
                    $vuetify.display.mdAndUp ? 'text-h6' : 'text-subtitle-1'
                "
                >Detalii produse</v-toolbar-title
            >
            <v-spacer></v-spacer>

            <!-- <v-checkbox v-if="location.compartmentation !== 0" :model-value="showTotalProducts" hide-details
                density="compact" class="mr-4" color="black" :label="$vuetify.display.mdAndUp ? 'Afișează total produse' : ''
                    " @update:model-value="onToggleTotalProducts" /> -->

            <!-- Desktop + Mobile  -->
            <template v-if="$vuetify.display.mdAndUp">
                <v-select
                    v-model="customizationValue"
                    :items="customizationOptionsFiltered"
                    item-value="value"
                    item-title="label"
                    label="Personalizare"
                    hide-details
                    density="compact"
                    variant="outlined"
                    class="mr-6"
                    style="max-width: 240px; min-width: 160px"
                />
            </template>

            <template v-else>
                <v-btn icon variant="text" title="Schimbă personalizarea">
                    <v-icon>mdi-tune-variant</v-icon>
                    <v-menu activator="parent">
                        <v-list>
                            <v-list-item
                                v-for="item in customizationOptionsFiltered"
                                :key="item.value"
                                @click="customizationValue = item.value"
                                :active="customizationValue === item.value"
                            >
                                <v-list-item-title>{{
                                    item.label
                                }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-btn>
            </template>
        </v-toolbar>

        <v-row no-gutters align="stretch" :key="`custom-${location.customization}`">
            <v-col
                v-for="u in customUnits"
                :key="`c${customizationType}-u${u.id}`"
                :md="unitSpanMd"
                :lg="unitSpanLg"
                class="d-flex"
            >
                <ProductUnitDetails
                    :title="u.label"
                    :location="uiLocation"
                    :initialData="unitInitialData(u.id)"
                    :insulation-types="insulationTypes"
                    :tacker-foil-types="tackerFoilTypes"
                    :additional-insulation-types="additionalInsulationTypes"
                   
                    @update="(payload) => onUnitUpdate(payload, u.id)"
                />
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import ProductUnitDetails from "@/components/offer/ProductUnitDetails.vue";
import { FLOOR_MAP } from "@/IPA/Floors";
import { APARTMENT_MAP } from "@/IPA/Apartments";
import { getApartamentLabel, getUnitId } from "@/utils/apartmentUtils";
import { CUSTOMIZATION_ENUM, CUSTOMIZATION_OPTIONS } from "@/IPA/Customization";

export default {
    name: 'ProductDetailsForm',
    components: { ProductUnitDetails },

    props: {
        // Parent owns the state; we mirror it via v-model
        modelValue: {
            type: Object, // shape: { [compType]: { [unitId]: {...payload} } }
            default: () => ({})
        },
      

        location: {
            type: Object,
            required: true // { rooms: [...], compartmentation: 0|1|2 }
        },
        insulationTypes: {
            type: Array
        },
        additionalInsulationTypes: {
            type: Array
        },
        tackerFoilTypes: {
            type: Array
        },
        showTotalProducts: {
            type: Boolean,
            default: false
        },
        showApartments: { type: Boolean, default: false },
        offerType: { type: Object, default: () => ({}) }
    },
    emits: [
        'update:modelValue',
        'update:showTotalProducts',
        'update-customization',
        'changed'
    ],

    data() {
        return {
            FLOOR_MAP,
            APARTMENT_MAP,
            customizationEnum: CUSTOMIZATION_ENUM,
            customizationOptions: CUSTOMIZATION_OPTIONS
        };
    },
    mounted() {
        this.localRooms = this.location?.rooms;
    },

    computed: {
        unitSpanLg() {
            if (this.customizationType === 0) return 12; // whole location
            const n = this.customUnits.length;
            if (n <= 1) return 12;
            if (n === 2) return 6;
            return 4;
        },
        unitSpanMd() {
            if (this.customizationType === 0) return 12; // whole location
            const n = this.customUnits.length;
            if (n <= 1) return 12;
            if (n === 2) return 6;
            return 6;
        },
        compartmentationOptionsFiltered() {
            return this.showApartments
                ? this.compartmentationOptions
                : this.compartmentationOptions.filter((o) => o.value !== 2);
        },
        customizationOptionsFiltered() {
            return this.showApartments
                ? this.customizationOptions
                : this.customizationOptions.filter((o) => o.value !== 2);
        },
        uiLocation() {
            const { customization, rooms } = this.location || {};
            return { customization, rooms };
        },

        customizationValue: {
            get() {
                const val = this.location?.customization;
                return val !== undefined && val !== null
                    ? Number(val)
                    : undefined;
            },
            set(value) {
                this.$emit('update-customization', value);
            }
        },
        customizationType() {
            return this.location?.customization ?? 0;
        },
        hasRooms() {
            return !!(
                this.location &&
                this.location.rooms &&
                this.location.rooms.length
            );
        },
        compType() {
            return Number(this.location.compartmentation ?? 0); // 0 = whole, 1 = floors, 2 = apartments
        },
        floors() {
            const s = new Set();
            for (const r of this.location.rooms || []) {
                if (r.floor !== undefined && r.floor !== null)
                    s.add(Number(r.floor));
            }
            return [...s].sort((a, b) => a - b);
        },
        apartments() {
            const s = new Set();

            for (const r of this.location.rooms || []) {
                const a = r.apartament ?? r.apartment ?? '0';
                s.add(String(a));
            }

            if (s.size === 0) s.add('0');

            return [...s].sort((a, b) => a - b);
        },

        customUnits() {
            switch (this.customizationType) {
                case 0:
                    return [{ id: 0, label: 'Întreaga locație' }];
                case 1:
                    return this.floors.map((f) => ({
                        id: f,
                        label: this.FLOOR_MAP[f] ?? `Etaj ${f}`
                    }));
                case 2:
                    return this.apartments.map((a) => ({
                        id: a,
                        label: getApartamentLabel(a)
                    }));
                default:
                    return [{ id: 0, label: 'Nedefinit' }];
            }
        }
    },

    methods: {
        /**
         * Retrieves initial configuration data for a specific unit.
         * Returns existing model data if available, otherwise builds default data.
         *
         * @param {string|number} unitId - The unique identifier of the unit.
         * @returns {Object} The configuration data for the specified unit.
         */
        unitInitialData(unitId) {
            const normalizedId = this.normalizeUnitId(
                unitId,
                this.customizationType
            );
            const existing =
                this.modelValue?.[this.customizationType]?.[normalizedId];
            if (existing) return existing;
            return this.getInitialData(unitId);
        },
        /**
         * Emits an event to toggle the visibility of total products.
         *
         * @param {boolean} value - True to show total products, false to hide.
         */
        onToggleTotalProducts(value) {
            this.$emit('update:showTotalProducts', value);
            this.$emit('changed');
        },
        /**
         * Updates data for a specific unit and emits the new model value.
         * Keeps only the data related to the current customization type.
         *
         * @param {Object} payload - Data payload to update the unit with.
         * @param {number|string} unitId - The unique identifier for the unit.
         */
        onUnitUpdate(payload, unitId) {
            const next = { ...(this.modelValue || {}) };

            if (!next[this.customizationType]) {
                next[this.customizationType] = {};
            }

            const normalizedId = this.normalizeUnitId(
                unitId,
                this.customizationType
            );

            if (!next[this.customizationType]) {
                next[this.customizationType] = {};
            }

            next[this.customizationType][normalizedId] = {
                unit: normalizedId,
                rawUnit: unitId,
                ...payload
            };

            this.$emit('update:modelValue', next);
            this.$emit('changed');

        },
        /**
         * Retrieves initial configuration data for a given unit.
         * The matching logic depends on the current customization type:
         * - 0: uses the first room
         * - 1: matches by floor
         * - 2: matches by apartment/apartament
         *
         * Returns merged defaults and matched room values.
         *
         * @param {number|string} unitId - Identifier of the unit to get data for.
         * @returns {Object} Initial configuration containing:
         *  - {number} pipeDiameter
         *  - {number} distributor
         *  - {number} metalBox
         *  - {number} temperatureRegulation
         *  - {number} automation
         *  - {number} reinforcementMesh
         */
        getInitialData(unitId) {
            const rooms = this.localRooms;
            let match = null;

            if (this.customizationType === 0) {
                match = rooms[0];
            } else if (this.customizationType === 1) {
                match = rooms.find((r) => Number(r.floor) === unitId);
            } else if (this.customizationType === 2) {
                match = rooms.find(
                    (r) =>
                        String(r.apartament ?? r.apartment) === String(unitId)
                );
            }

            //  Default values if nothing found
            const defaults = {
                pipeDiameter: 17, // 17mm
                distributor: 3, // Modular cu eurocon
                metalBox: 2, // Sistemă
                temperatureRegulation: 1, // Nu
                automation: 1, // Nu
                reinforcementMesh: 1, // Da
                automationSelection: []
            };

            //  Merge defaults + room values
            return {
                pipeDiameter: match?.pipe_diameter ?? defaults.pipeDiameter,
                distributor: match?.distributor ?? defaults.distributor,
                metalBox: match?.metal_box ?? defaults.metalBox,
                temperatureRegulation:
                    match?.temperature_regulation ??
                    defaults.temperatureRegulation,
                automation: match?.automation ?? defaults.automation,
                automationSelection:
                    match?.automationSelection ??
                    match?.automation_selection ??
                    defaults.automationSelection,
                reinforcementMesh:
                    match?.reinforcement_mesh ?? defaults.reinforcementMesh,
                insulationType:
                    match?.insulationType ?? defaults.insulationType,
                tackerFoil: match?.tackerFoil ?? defaults.tackerFoil,
                additionalInsulations:
                    Array.isArray(match?.additionalInsulations) &&
                    match.additionalInsulations.length
                        ? match.additionalInsulations
                        : defaults.additionalInsulations
            };
        },
        normalizeUnitId(unitId, type = this.customizationType) {
            if (type !== 2) return unitId;

            if (typeof unitId === 'string' && unitId.startsWith('unit_')) {
                return unitId;
            }

            const normalized = getUnitId(unitId);
            if (normalized) return normalized;

            return unitId == null ? unitId : String(unitId);
        }
    },
    watch: {
        'location.rooms': {
            immediate: true,
            deep: true,
            handler(rooms) {
                if (!rooms?.length) return;

                const currentType = this.customizationType;
                const next = { ...(this.modelValue || {}) };

                this.localRooms = rooms;

                if (!next[currentType]) next[currentType] = {};

                this.customUnits.forEach((u) => {
                    const normalizedId = this.normalizeUnitId(
                        u.id,
                        currentType
                    );
                    const existing = next[currentType][normalizedId];
                    const initial = this.getInitialData(u.id);

                    next[currentType][normalizedId] = {
                        ...initial,
                        ...existing,
                        insulationType:
                            existing?.insulationType || initial.insulationType,
                        tackerFoil: existing?.tackerFoil || initial.tackerFoil,
                        additionalInsulations: existing?.additionalInsulations
                            ?.length
                            ? existing.additionalInsulations
                            : initial.additionalInsulations
                    };
                });

                this.$emit('update:modelValue', next);
            }
        }
    }
};
</script>
